module.exports = __webpack_public_path__ + "static/media/logo-gp-pl.370be981.png";